// 权益管理
import $ from '../base'

export default {

  // 手动充值
  manualRecharge: $.post('order/manualRecharge'),

  // 批量充值
  batchRecharge: $.BASE_URL + 'order/batchRecharge',

  // 批量充值 - 订单列表
  batchOrderList: $.post('order/queryBatchRechargeList'),

  // 批量充值 - 导出失败订单
  exportBatchFailList: $.BASE_URL + 'order/outFailOrder'

}
